import { FC } from 'react'
import { CalendarPlus, FileText, CheckCircle2, ClipboardList, ShoppingCart, PackageCheck, FileSpreadsheet } from 'lucide-react'
import CardInfoButton from './CardInfoButton'
import type { CardMeta } from './types'

interface QuickAction {
  label: string
  sub: string
  icon: FC<{ className?: string }>
  bg: string
  iconColor: string
  action: string
}

interface Props {
  onAction: (action: string) => void
}

const actions: QuickAction[] = [
  { label: 'Schedule Job', sub: 'Plan maintenance', icon: CalendarPlus, bg: 'bg-orange-100', iconColor: 'text-orange-600', action: 'scheduleJob' },
  { label: 'Create Job Card', sub: 'Create new job', icon: FileText, bg: 'bg-blue-100', iconColor: 'text-blue-600', action: 'createJobCard' },
  { label: 'Close Job', sub: 'Mark job as complete', icon: CheckCircle2, bg: 'bg-emerald-100', iconColor: 'text-emerald-600', action: 'closeJob' },
  { label: 'Raise Requisition', sub: 'Request items', icon: ClipboardList, bg: 'bg-orange-100', iconColor: 'text-orange-600', action: 'raiseRequisition' },
  { label: 'Create PO', sub: 'Create purchase order', icon: ShoppingCart, bg: 'bg-amber-100', iconColor: 'text-amber-600', action: 'createPO' },
  { label: 'Goods Receipt', sub: 'Record received items', icon: PackageCheck, bg: 'bg-sky-100', iconColor: 'text-sky-600', action: 'goodsReceipt' },
  { label: 'Upload Bulk Machinery Sheet', sub: 'Import Bulk Machinery Sheet', icon: FileSpreadsheet, bg: 'bg-teal-100', iconColor: 'text-teal-600', action: 'uploadMachinery' },
]

const quickActionsMeta: CardMeta = {
  description: 'Quick action buttons to navigate to commonly used PMS and Procurement features.',
  endpoint: 'N/A — Client-side navigation actions',
  logic: 'Each button opens a modal with the corresponding route or action.',
}

const QuickActions: FC<Props> = ({ onAction }) => {
  return (
    <div className='flex items-center justify-between gap-4'>
      <h1 className='text-xl font-bold text-slate-900'>Quick Actions</h1>
      <CardInfoButton meta={quickActionsMeta} />
    </div>
  )
}

export default QuickActions
